import { createSelector } from 'reselect';
import { RootState } from '../store';

/**
 * Creates a selector which returns a object where the product id is key and T is value.
 * 
 * @param selector
 *      the selector to get the object to turn into a product lookup selector
 */
export function createProductLookupSelector<T extends { productId: number }>(
    selector: (state: RootState) => { [key: string]: T }
) {
    return createSelector([selector], toProductLookup);
}

function toProductLookup<T extends { productId: number }>(values: { [key: string]: T }) {
    const lookup: { [productId: number]: T } = {};
    for (const value of Object.values(values)) {
        lookup[value.productId] = value;
    }
    return lookup;
}
